import { client } from '@utils';

const BASE = 'scheduling';

const getRoles = () => client.authorized.get(`${BASE}/roles`);
const createRole = data => client.authorized.post(`${BASE}/roles`, data);
const updateRole = data => client.authorized.put(`${BASE}/roles`, data);
const deleteRole = data => client.authorized.delete(`${BASE}/roles`, { data });

const getEmployees = () => client.authorized.get(`${BASE}/employees`);
const createEmployee = data => client.authorized.post(`${BASE}/employees`, data);
const updateEmployee = data => client.authorized.put(`${BASE}/employees`, data);
const deleteEmployee = data => client.authorized.delete(`${BASE}/employees`, { data });

const getWeekSchedule = weekStart => client.authorized.get(`${BASE}/schedule`, { params: { week_start: weekStart } });

const createShift = data => client.authorized.post(`${BASE}/shifts`, data);
const updateShift = data => client.authorized.put(`${BASE}/shifts`, data);
const deleteShift = data => client.authorized.delete(`${BASE}/shifts`, { data });
const publishWeek = data => client.authorized.post(`${BASE}/shifts/publish`, data);

const getTimeOffRequests = () => client.authorized.get(`${BASE}/time-off`);
const createTimeOffRequest = data => client.authorized.post(`${BASE}/time-off`, data);
const reviewTimeOffRequest = data => client.authorized.put(`${BASE}/time-off/review`, data);

const getShiftTrades = () => client.authorized.get(`${BASE}/trades`);
const reviewShiftTrade = data => client.authorized.put(`${BASE}/trades/review`, data);

export default {
  getRoles,
  createRole,
  updateRole,
  deleteRole,
  getEmployees,
  createEmployee,
  updateEmployee,
  deleteEmployee,
  getWeekSchedule,
  createShift,
  updateShift,
  deleteShift,
  publishWeek,
  getTimeOffRequests,
  createTimeOffRequest,
  reviewTimeOffRequest,
  getShiftTrades,
  reviewShiftTrade,
};
